import { SsoTokenVO, UserVO } from "./sso.models";
import { SigninResponseVO } from "../signin/signin.models";

export abstract class SsoService {

    abstract clear(): void;

    abstract saveSigninResponse(signinResponseVO: SigninResponseVO): void;

    abstract getToken(refreshIfExpired: boolean): Promise<SsoTokenVO>;

    abstract getUserDetails(): UserVO;

    abstract updateUserDetails(userVO: UserVO): void;
}


// WEBPACK FOOTER //
// ./src/app/sso/sso.service.ts